const options = {
  dev360mapsapi: 'DEV',
  qa360mapsapi: 'QA',
  '360mapsapi': 'PROD',
};

const [api] = process.env.REACT_APP_360_API.split('//')[1].split('.');
const env = options[api];

const getExt = (fileName) => {
  const splitName = fileName.split('.');
  return splitName[splitName.length - 1];
};

export const generateCloudinaryLink = ({ map, id, fileName, params }) =>
  `https://res.cloudinary.com/concept3d/image/upload/${
    params ? `${params}/` : ''
  }v1595334750/360_maps_textures/${env || 'DEV'}/${map}/${id}/${fileName}.${
    fileName && getExt(fileName)
  }`;
